import { Component, ChangeDetectionStrategy, ViewChild, Inject } from "@angular/core";
import { FormFieldArrayComponent } from "./form-field-array-component";
import { FormRootDirective } from "../../form/form-root.directive";
import { FIELD_NAME } from "../form-field-injector";

@Component({
  selector: "dynamic-form-array-default",
  template: `
    <div class="array-default">
      <label>
        <h3>{{ name }}</h3>
      </label>
      <form-root></form-root>
    </div>
  `,
  styles: [
    `
      .array-default {
        border: 1px solid grey;
        padding: 5px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArrayComponent implements FormFieldArrayComponent {
  @ViewChild(FormRootDirective, { static: true })
  formRoot: FormRootDirective;
  constructor(@Inject(FIELD_NAME) public name: string) {}
}
